<style lang="scss" scoped>
.card-table {
  margin-bottom: 0;
}
</style>

<template>
  <section>
    <v-table
      url="/api/v1/customerProfile"
      :filter="[
        {
          name: 'AffiliateRevenue',
          value: id
        },
        {
          name: 'sort',
          mode: 'DESC',
          attribute: 'revenue'
        }
      ]"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name',
          type: 'ProfileCell'
        },
        {
          attribute: 'revenue',
          name: 'Umsatz',
          type: 'CurrencyCell'
        },
        {
          attribute: 'latest',
          name: 'Letzter Kauf',
          type: 'DateTimeCell'
        }
      ]"
    ></v-table>
  </section>
</template>

<script lang="babel">
export default {
  props: ["id"]
};
</script>
